import { render, staticRenderFns } from "./emailTemplate.vue?vue&type=template&id=2f7be82e&scoped=true"
import script from "./emailTemplate.vue?vue&type=script&lang=js"
export * from "./emailTemplate.vue?vue&type=script&lang=js"
import style0 from "./emailTemplate.vue?vue&type=style&index=0&id=2f7be82e&prod&lang=scss&scoped=true"
import style1 from "./emailTemplate.vue?vue&type=style&index=1&id=2f7be82e&prod&lang=scss"
import style2 from "./emailTemplate.vue?vue&type=style&index=2&id=2f7be82e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7be82e",
  null
  
)

export default component.exports